import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Card } from '@hivebrite/design-system/Card';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { MEDIA_CENTER_COVER_SIZE } from 'hb-react/backoffice/apps/MediaCenter/constants';
import ThumbnailContent from 'hb-react/shared/components/Thumbnails/components/ThumbnailContent';

const WrapperContent = ({ children, tag, isFolder, preview, ...rest }) => {
  const breakpoint = useBreakpoint();

  const OuterWrapper = isFolder ? FolderWrapper : FileWrapper;

  return (
    <OuterWrapper $breakpoint={breakpoint}>
      <ThumbnailContent tag={tag}>
        <WrapperStyled {...rest}>{preview}</WrapperStyled>
      </ThumbnailContent>
      {children}
    </OuterWrapper>
  );
};

export default WrapperContent;

const FileWrapper = styled(Card).attrs({
  width: '55%',
  display: 'flex',
  flexDirection: 'column',
})`
  padding: 0;
  position: relative;
`;

const FolderWrapper = styled(Card).attrs({
  width: '55%',
  display: 'flex',
  flexDirection: 'column',
  mt: { _: '16px', m: '26px' },
})`
  padding: 0;
  position: relative;
`;

export const WrapperStyled = styled(Box).attrs((props) => ({
  ...props,
  flexDirection: 'column',
  width: { _: 'unset', m: '100%' },
}))`
  aspect-ratio: ${() => MEDIA_CENTER_COVER_SIZE.aspectRatio};
  word-break: break-word;
  border-top-left-radius: ${({ theme }) =>
    theme.themeVariables.globalBorderRadius}px;
  border-top-right-radius: ${({ theme }) =>
    theme.themeVariables.globalBorderRadius}px;

  // Needed to force the style in embedly video and link to fit the design
  & video,
  a {
    aspect-ratio: ${() => MEDIA_CENTER_COVER_SIZE.aspectRatio};
    background-color: ${({ theme }) => theme.colors.white};
    border-top-left-radius: ${({ theme }) =>
      theme.themeVariables.globalBorderRadius}px;
    border-top-right-radius: ${({ theme }) =>
      theme.themeVariables.globalBorderRadius}px;
  }
`;
